import { routerReducer } from 'react-router-redux';
import { reducer as formReducer } from 'redux-form';
import { persistReducer } from 'redux-persist';
import { combineReducers } from 'redux';
import storage from 'redux-persist/lib/storage';

import authReducer from '../views/Login/reducer';
import chatReducer from '../views/Dashboard/reducer';

const config = {
    key: 'root',
    storage,
};

const combinedReducer = combineReducers({
  routing: routerReducer,
  form: formReducer,
  authReducer,
  chatReducer,
});

const appReducer = persistReducer(config, combinedReducer);

export default appReducer;
